<template>
  <div class="index">
    <van-search
      background="#fff"
      placeholder="请输入搜索关键词"
      @click="goSearch('')"
    />
    <van-collapse v-model="activeNames">
      <van-collapse-item
        disabled
        class="collapseItem"
        v-for="(i, ind) in list"
        :name="ind"
        :key="ind"
      >
        <template #title>
          <div style="display: flex; align-items: center">
            <i class="cricl">{{ ind + 1 }}</i>
            <span style="font-weight: 600; color: #237DFF">{{ i.title }}</span>
            <div class="showA" @click="i.showAll = !i.showAll">
              <van-icon name="arrow-down" v-if="!i.showAll" size="20" />
              <van-icon name="arrow-up" size="20" v-else />
            </div>
          </div>
        </template>
        <div class="list">
          <p
            v-for="(j, index) in i.list"
            v-show="i.showAll ? true : index < 6"
            :key="index"
            @click="goDetails(j.id)"
          >
            {{ j.title }}
          </p>
        </div>
      </van-collapse-item>
    </van-collapse>
    <div class="bottomText">
      本话术库由汇添富基金联合启势广告开发<br />
      版权所有。基金有风险，投资须谨慎
    </div>
    <tab></tab>
  </div>
</template>

<script>
import { catalogList } from "@/api/index";

import tab from "@/components/tab";
export default {
  name: "index1",
  components: { tab },
  data() {
    return {
      activeNames: [0, 1, 2, 3, 4, 5, 6],
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      catalogList()
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            let list = res.data.list;
            list.forEach((i) => {
              i.showAll = false;
            });
            this.list = list;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    goDetails(id) {
      this.$router.push({
        path: "/details",
        query: {
          id: id,
        },
      });
    },
    goSearch(item) {
      this.$router.push({
        path: "/search",
        query: {
          msg: item,
        },
      });
    },
  },
};
</script>
<style lang="less">
.index {
  width: 94%;
  min-height: 82vh;
  margin: 0 auto;
  padding-bottom: 7.5rem;
  position: relative;
  h5 {
    margin: 0.625rem 0;
  }
  .van-search {
    padding: 0.625rem 0;
    margin-bottom: 0.6rem;
  }
  .van-search__content {
    padding-left: 0;
  }
  .van-search .van-cell {
    line-height: 2rem;
    background: #f4f4f4;
    border-radius: 3.125rem;
    padding: 0 0.625rem;
    box-sizing: border-box;
  }
  .van-cell--clickable {
    background: #fff;
  }
  .collapseItem {
    margin-bottom: 1.2rem;
    border-radius: 0.875rem;
    overflow: hidden;
    box-shadow: 0rem 0.125rem 0.75rem 0rem rgba(0, 0, 0, 0.12);
    .cricl {
      display: inline-block;
      width: 1.25rem;
      height: 1.25rem;
      line-height: 1.25rem;
      margin-right: 0.625rem;
      background-image: linear-gradient(to bottom, #1830FF, #79ADFF);
      border-radius: 50%;
      font-style: normal;
      text-align: center;
      color: #fff;
      font-weight: 600;
    }
    .showA {
      background: #fff;
      width: 6.25rem;
      height: 1.875rem;
      position: absolute;
      right: 0;
      z-index: 10;
      text-align: right;
      padding-right: 0.625rem;
      line-height: 2.1875rem;
    }
    .list {
      color: #333;
      p {
        padding: 0.3125rem 0;
        border-bottom: 0.0625rem solid #d8d8d8;
        &:last-child {
          border-bottom: 0;
        }
      }
    }
  }
  .bottomText {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 3.8rem;
    font-size: 0.75rem;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index2.vue